import { commonViewTexts } from '../common';

export const labelListViewTexts = {
  buttons: {
    edit: commonViewTexts.edit,
    discard: '編集内容を破棄',
    save: commonViewTexts.save,
    add: 'ラベル追加'
  },
  description: 'ラベルの新規追加や編集・削除を行います。',
  header: {
    labelName: 'ラベル名',
    color: '色'
  },
  inputLabel: 'ラベル名',
  messages: {
    error: 'アップロード時にエラーが発生しました。',
    labelIsNotDeletable:
      '既にアノテーションに使用されているラベルは削除できません。'
  }
} as const;
